import React from 'react';

interface RacingTyreIconProps {
  size?: number;
}

const RacingTyreIcon: React.FC<RacingTyreIconProps> = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 90 90"
    fill="currentColor"
    aria-hidden="true"
  >
    <circle cx="45" cy="45" r="27.652" opacity="0.55" />
    <path
      d="M45 0C20.147 0 0 20.147 0 45s20.147 45 45 45 45-20.147 45-45S69.853 0 45 0Zm0 72.652C29.728 72.652 17.348 60.272 17.348 45S29.728 17.348 45 17.348 72.652 29.728 72.652 45 60.272 72.652 45 72.652Z"
      opacity="0.78"
    />
    <path
      d="M45.001 15.694C28.842 15.694 15.695 28.84 15.695 45c0 16.159 13.147 29.306 29.306 29.306S74.305 61.159 74.305 45C74.305 28.84 61.159 15.694 45.001 15.694Zm22.978 17.181-9.411 2.967c-.681.215-1.376.321-2.064.321-1.418 0-2.807-.449-3.995-1.32-1.763-1.294-2.776-3.29-2.776-5.478v-9.91c7.92 1.464 14.59 6.518 18.246 13.42ZM52.213 45c0 3.983-3.229 7.213-7.213 7.213S37.787 48.983 37.787 45s3.229-7.213 7.213-7.213S52.213 41.017 52.213 45ZM40.267 19.454v9.91c0 2.188-1.013 4.184-2.776 5.478-1.189.871-2.577 1.321-3.995 1.321-.686 0-1.381-.106-2.062-.321l-9.413-2.968c3.656-6.901 10.325-11.955 18.246-13.42ZM19.002 45c0-1.048.08-2.075.201-3.091l9.073 2.861c2.08.656 3.729 2.283 4.41 4.355.681 2.074.32 4.363-.966 6.125l-5.557 7.616C21.738 58.203 19.002 51.921 19.002 45ZM33.819 68.435l5.696-7.806c1.294-1.773 3.293-2.789 5.486-2.789 2.195 0 4.194 1.016 5.487 2.789l5.697 7.804c-3.393 1.627-7.177 2.565-11.185 2.565-4.008 0-7.791-.937-11.181-2.563ZM63.837 62.865l-5.556-7.614c-1.285-1.76-1.647-4.05-.967-6.122.681-2.074 2.33-3.702 4.41-4.359l9.072-2.861c.121 1.015.201 2.043.201 3.091 0 6.921-2.735 13.202-7.16 17.865Z"
      fill="currentColor"
    />
  </svg>
);

export default RacingTyreIcon;
